import React from "react";
import { Box, Chip, TextField, Typography } from "@mui/material";
import { ColorsConstants, borderColors, inputColor } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

// Number input (hours) + quick-select preset chips, e.g. "clean up queue after N
// hours of inactivity" with 6h/12h/24h/48h shortcuts. Presets only highlight when the
// current value matches one exactly; typing a custom value clears the highlight.
const HourPresetInput = ({
  value,
  onChange,
  presets = [6, 12, 24, 48],
  min = 1,
  max = 168,
  unitLabel = "hours of inactivity",
}) => {
  const handleNumberChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      onChange(raw);
      return;
    }
    const parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed)) onChange(Math.min(Math.max(parsed, min), max));
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
        <TextField
          type="number"
          value={value}
          onChange={handleNumberChange}
          inputProps={{ min, max }}
          sx={{
            width: 90,
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              color: inputColor,
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: borderColors.inputFieldGrey,
              },
            },
            "& input": { padding: "8px 10px", ...typography.bodyLarge },
          }}
        />
        <Typography sx={{ ...typography.bodySmall, color: ColorsConstants.primaryGray60 }}>
          {unitLabel}
        </Typography>
        <Typography sx={{ ...typography.bodySmall, color: ColorsConstants.primaryGray40, ml: "auto" }}>
          Max: {max} hrs ({Math.round(max / 24)} days)
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        {presets.map((preset) => {
          const selected = Number(value) === preset;
          return (
            <Chip
              key={preset}
              label={`${preset}h`}
              clickable
              onClick={() => onChange(preset)}
              variant="outlined"
              sx={{
                ...typography.bodySmall,
                fontWeight: 500,
                borderColor: selected ? ColorsConstants.primaryPurple100 : borderColors.inputFieldGrey,
                color: selected ? ColorsConstants.primaryPurple100 : inputColor,
                backgroundColor: selected ? ColorsConstants.primaryPurple60 : "transparent",
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default HourPresetInput;
